import * as TYPES from './actions/types';

export const initialState = {
  followUpPlan: null,
};

const followUpPlansReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.FOLLOWUP_PLAN_LOAD_SUCCESS: {
      newState = { ...state, ...action.state };
      break;
    }
    case TYPES.FOLLOWUP_PLAN_LOAD_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.FOLLOWUP_PATIENT_NOTIFY_PREFERENCE_LOADED: {
      newState = { ...state, patientNotifyPreference: action.patientNotifyPreference };
      break;
    }
    default:
      newState = state;
  }

  return newState;
};

export default followUpPlansReducer;
